import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-grid";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host {" : hostSelector + " {")) + "--wds-modal-z-index: 3000;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];